var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotificationsNew = function SvgNotificationsNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.533 23.618c-2.56-1.152-2.658-6.096-2.66-6.22V14.08c0-3.193-1.959-5.938-4.742-7.106A2.995 2.995 0 0 0 16.133 4a2.995 2.995 0 0 0-2.997 2.974c-2.784 1.17-4.743 3.914-4.743 7.107v3.316c-.001.125-.099 5.069-2.66 6.22a.676.676 0 0 0 .28 1.294h6.492c.133.73.48 1.408 1.01 1.957A3.617 3.617 0 0 0 16.132 28c.985 0 1.916-.402 2.619-1.132.53-.55.876-1.227 1.009-1.957h6.492a.676.676 0 0 0 .28-1.294zM23.16 21.25c.269.812.65 1.629 1.19 2.308H7.916c.54-.68.921-1.496 1.19-2.308H23.16zM16.133 5.354a1.64 1.64 0 0 1 1.574 1.18 7.775 7.775 0 0 0-3.148 0 1.64 1.64 0 0 1 1.574-1.18zM9.753 17.4v-3.32c0-3.504 2.862-6.355 6.38-6.355s6.38 2.85 6.38 6.355v3.326c.002.102.017 1.172.288 2.489H9.465c.27-1.319.287-2.39.288-2.495zm6.38 9.246c-1.037 0-1.942-.745-2.233-1.736h4.466c-.29.99-1.196 1.736-2.233 1.736z",
    fill: "#2E3451",
    stroke: "#2E3451",
    strokeWidth: 0.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 8.001,
    fill: "#D30000",
    r: 5.333
  })));
};
export default SvgNotificationsNew;